import { msg } from '@lingui/core/macro';
import Banner from '../ui/Banner';
import type { LocalizedMessage } from '../../lib/i18n/messages';
import { projectCreationTrialLabel } from '../../lib/projectCreationEntitlements';

interface Props {
    error: LocalizedMessage | null;
    subscriptionRequired: boolean;
    expired: boolean;
    onStartTrial: () => void;
    onRestart: () => void;
    onRetry?: () => void;
    onRestore?: () => void;
}

export default function ProjectActivationErrorBanner({
    error, subscriptionRequired, expired, onStartTrial, onRestart, onRetry, onRestore,
}: Props) {
    if (!error) return null;
    const retry = expired ? onRestart : onRetry || onRestore;
    return <Banner
        type="error"
        title={msg({ id: 'onboarding.activation.openError', message: 'Could not open your project' })}
        message={error}
        action={subscriptionRequired
            ? { label: projectCreationTrialLabel, onPress: onStartTrial }
            : retry ? { label: msg({ id: 'common.retry', message: 'Retry' }), onPress: retry }
                : undefined}
    />;
}
